import React, { useCallback } from 'react';
import { SelectPicker } from 'rsuite';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

export default function SelectState({
  selectedState,
  setSelectedStates,
  marginRight,
  setUfSelecionado,
  container,
  searchable,
  style,
}) {
  const states = useSelector((state) => state.states) || [];

  const handleChange = useCallback(
    (value) => {
      if (typeof setSelectedStates === 'function') {
        setSelectedStates(value);
      }

      if (typeof setUfSelecionado === 'function') {
        if (value == null) {
          setUfSelecionado(undefined);
          return;
        }

        const estadoEncontrado = states.find((estado) => estado.id === value);

        if (estadoEncontrado) {
          setUfSelecionado(estadoEncontrado.uf);
        }
      }
    },
    [setSelectedStates, setUfSelecionado, states]
  );

  return (
    <SelectPicker
      appearance="default"
      style={{
        marginRight: marginRight ? '15px' : 0,
        ...style,
      }}
      placeholder="Estado"
      searchable={searchable}
      cleanable
      data={states.map((estado) => ({
        label: estado.estado
          ? `${estado.uf} - ${estado.estado}`
          : estado.uf,
        value: estado.id,
      }))}
      value={selectedState}
      container={container}
      onChange={handleChange}
    />
  );
}

SelectState.propTypes = {
  selectedState: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setSelectedStates: PropTypes.func.isRequired,
  marginRight: PropTypes.bool,
  setUfSelecionado: PropTypes.func,
  container: PropTypes.func,
  searchable: PropTypes.bool,
  style: PropTypes.shape({
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

SelectState.defaultProps = {
  marginRight: false,
  selectedState: null,
  setUfSelecionado: undefined,
  container: undefined,
  searchable: true,
  style: undefined,
};
